<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" />
    </div>
</template>

<script>
export default {
  name: 'DrillActionsCellRenderer',
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },

    openDeleteConfirm() {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Drills.ConfirmDelete'),
        accept: () => this.deleteRecord()
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.drillRigId);
    }
  }
}
</script>
